import { Component } from "react";



class About extends Component {
    render() { 
        return (
            <section className="about padding-top padding-bottom">
                <div className="container">
                    <div className="about__wrapper">
                        <div className="row g-5 align-items-center">
                            <div className="col-lg-6">
                                <div className="about__thumb" data-aos="fade-zoom-in" data-aos-duration="1000">
                                    <img src="assets/images/about/01.png" alt="About Image" />
                                </div>
                            </div>
                            <div className="col-lg-6">
                                <div className="about__content" data-aos="fade-up" data-aos-duration="1000">
                                    <h2>6999 Unique <br /> Cute Monster NFT</h2>
                                    <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Voluptas de leniti within voluptatibus officia! Ipsum porro repellendus quis fuga illooxe officia, amet rem culpa quidem magni incidunt vitae accusamus.</p>
                                    <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Voluptas de leniti within voluptatibus officia! Ipsum porro repellendus quis fuga illooxe officia, amet rem culpa quidem magni incidunt vitae accusamus.</p>
                                    <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Voluptas de leniti within voluptatibus officia! Ipsum porro repellendus quis fuga illooxe officia, amet rem culpa quidem magni incidunt vitae accusamus.</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        );
    }
}
 
export default About;